import { Component, effect, inject, ChangeDetectorRef, DestroyRef, ChangeDetectionStrategy, Injector, afterNextRender, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, NavigationEnd, RouterLink } from '@angular/router';
import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Subject, fromEvent, BehaviorSubject, filter, debounceTime, distinctUntilChanged, Subscription, switchAll, map, switchMap, tap, Observable, of, catchError, skip, forkJoin } from 'rxjs';

import { SpinnerService } from '@app/shared/spinner.service';
import { AlertService } from '@app/shared/alert.service';
import { PrintService } from '@app/shared/print.service';
import { AttachService } from '@app/shared/attach/attach.service';
import { QuotationService } from '@app/sales/quotation/quotation.service';
import { PartnersService } from '@app/common/partners/partners.service';
import { SalesService } from '@app/sales/sales.service';
import { ServerStatusService } from '@app/common/server-status.service';
import { SearchPartnerComponent } from '@app/shared/search-partner/search-partner.component';
import * as utils from '@app/shared/util';
import Swal from 'sweetalert2';

import { PartnersComponent } from '@app/common/partners/partners.component';
// La fiche tiers (common/partner) — c'est elle que le nom du client ouvre (openPartnerDialog).
import { PartnerComponent } from '@app/common/partner/partner.component';
import { PartnerService } from '@app/common/partner/partner.service';
import { QuotationdocsComponent } from '@app/sales/quotation/quotationdocs/quotationdocs.component';
import { QuotationoptionsComponent } from '@app/sales/quotation/quotationoptions/quotationoptions.component';
// import { PlanificationdeliveryComponent } from '@app/logistic/delivery/planificationdelivery/planificationdelivery.component';   // old when we plan liv in the quotation page
import { QuotationgeneralComponent } from '@app/sales/quotation/quotationgeneral/quotationgeneral.component';
import { DeliveryComponent } from '@app/logistic/delivery/delivery.component';
import { RentalDeliveryDialogComponent } from '@app/rental/rental-delivery-dialog/rental-delivery-dialog.component';
import { ActionBarComponent } from '@app/shared/action-bar/action-bar.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuotationActionComponent } from '@app/shared/action-bar/quotation-action/quotation-action.component';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgClass, DatePipe, AsyncPipe, DecimalPipe, formatNumber } from '@angular/common';
import { FormatIntegerPipe } from '@app/shared/pipes/format-integer.pipe';
import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';
import { SalehistoryComponent } from '@app/sales/quotation/salehistory/salehistory.component';
import { A11yModule } from '@angular/cdk/a11y';
import { Parser } from 'xml2js';
import { SmartSelectComponent } from '@app/shared/smart-select/smart-select.component';

import { ThumbDeliveryTypeComponent } from './thumb-delivery-type/thumb-delivery-type.component';
import { RentgeneralComponent } from './rentgeneral/rentgeneral.component';
import { TakeDepositDialogComponent } from './take-deposit-dialog/take-deposit-dialog.component';
import { UseAvoirDialogComponent } from './use-avoir-dialog/use-avoir-dialog.component';
import { DeliveryValidationComponent } from '@app/logistic/delivery/delivery-validation/delivery-validation.component';
import { SignDocDialogComponent } from './sign-doc-dialog/sign-doc-dialog.component';
import { OfflineBannerComponent } from '@app/shared/offline-banner/offline-banner.component';
import { C_value, ApiResponse } from '@app/shared/_models/common';
import { ActionBarStatus } from '@app/shared/_models/common';

import { SafePeriod, Sales_order, SalesOrderForm, periodHardLimit, periodLimitPhrase, Delivery, RentalBilling, rentalBillingOf } from '@app/shared/_models/sales';
import { Event, Partner, User, Store, Station } from '@app/shared/_models/common';
import { LoginService } from '@app/common/login.service';
import { CommonService } from '@app/common/common.service';
import { ValuesService } from '@app/common/values/values.service';
import { showError } from '@app/shared/util';
import { businessDayOf } from '@app/shared/time';

import { SalesOrderState, cufSystem, OrderLineType, SalesOrderAction } from '@app/shared/constants-server';
import { sales_order_mode, salesOrderColors, getOrderColor, getOrderLabel, getStateKey, getStateEnum, isSealedOrder, isOrderEditable, tradeDocFor, TradeDoc, EVENTTYP_INSERT, EVENTTYP_UPDATE, DocType, PARTNER_PARTNER_ROLE_BILL, PARTNER_PARTNER_ROLE_DELIV, isRentalInvoice, RENTAL_INVOICE_NO_MANUAL_CREDIT } from '@app/shared/constants';

import { EmpreinteCV, FSEOrder, ConfigArea } from 'mercalink-fselib';
import { FseService } from '@app/fse/fse.service';

import { QuotationFseProcessorService, QuotationFseActions } from './custom-FSE/fse-processor.service';
import { NewSaleKind, NewSaleService, NEW_SALE_DOCUMENTS, NEW_SALE_KINDS, openSaleForCustomer } from './new-sale.service';
import { SaleOrderApi, placeSaleLines, saleOrderHeadOf } from '@app/sales/rental-contract/rental-sale-order';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss'],
  imports: [SmartSelectComponent, MenuCommonComponent, AsyncPipe, A11yModule, ThumbDeliveryTypeComponent, FormsModule, ReactiveFormsModule, MatButtonModule, MatExpansionModule, MatTooltipModule, NgClass, ActionBarComponent, QuotationActionComponent, MatTabsModule, QuotationgeneralComponent, RentgeneralComponent, QuotationoptionsComponent, QuotationdocsComponent, DatePipe, DecimalPipe, FormatIntegerPipe, SalehistoryComponent, MatIcon, MatFormFieldModule, MatInputModule, MatAutocompleteModule, SearchPartnerComponent, OfflineBannerComponent, RouterLink],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class QuotationComponent {
  public SalesOrderState = SalesOrderState; // Re export for GUI
  public salesOrderColors = salesOrderColors;
  public sales_order_mode = sales_order_mode;
  public getOrderColor = getOrderColor;
  public getOrderLabel = getOrderLabel;
  public DocType = DocType;
  //public constants = constants;
  public apiResponseClients: any;

  public id: number = 0;
  public eventtyp: number = EVENTTYP_INSERT; // Insert event by default
  public formGroup!: FormGroup<SalesOrderForm>;
  public customer: any | undefined; // Linked customer. Easier to deal w/ compared to formGroup.lnk_customer
  public addr_liv_index: any; // TODO What's the use of this?
  public selectedtab: number = 0; // TODO Force selected tab for dev. purpose
  public sideTab: number = 0; // Panneau latéral : 0 historique client, 1 documents attachés
  private sideTabFor = -1; // pièce pour laquelle sideTab a été posé : la recharger ne réimpose pas l'onglet
  private savedSnapshot = ''; // formulaire tel que chargé (recalcul des enfants compris), comparé avant d'imprimer ou de faire signer
  // public searchnamefocus = false;
  public cvlookup: boolean = false; // Lookup by carte vitale
  public is_ht: boolean = false;
  public group_packagings: boolean = true;

  //public periods: Array<SafePeriod> = [];	// Periods -- 0:Year, 1:Month, 2:Day
  public yearPeriod?: SafePeriod;
  public monthPeriod?: SafePeriod;
  public dayPeriod?: SafePeriod;
  public dataOk: boolean = false;
  public dataError: boolean = false;
  public isValidable: boolean = true;
  public fseOrders!: FSEOrder[]; // Fses related to this order, if any
  /** Factures enfants générées à partir du présent contrat parent (lorsque doc_type = LOCATION). */
  public childInvoices: Sales_order[] = [];
  public NoDocumentError: boolean = false;
  public remainder: number = 0;

  // Compteur d'ÉPOQUE du document affiché : incrémenté à chaque remise à zéro. Tout traitement
  // asynchrone qui vise le document courant (l'enregistrement, essentiellement) fige cette valeur
  // au départ et refuse d'aboutir si elle a changé — sinon il agirait sur le document SUIVANT.
  private resetEpoch: number = 0;

  // Drapeau de MONTAGE du corps de la page. À false, le gabarit démonte tout le sous-arbre de
  // saisie — en-tête, barre d'action, onglets, lignes, historique client. C'est le seul moyen
  // d'obtenir une remise à zéro RÉELLE sans navigation : voir resetToNewOrder().
  // `<app-menu-common>` reste hors du bloc gardé — le menu porte l'écoute clavier, le démonter
  // couperait la main qui vient d'appuyer sur la touche.
  public mounted: boolean = true;

  // Deprecated, view signal below
  //@ViewChild('searchnameInput', { static: true }) searchNameInput: ElementRef<HTMLInputElement> = {} as ElementRef;
  readonly quotationGeneral = viewChild(QuotationgeneralComponent);

  qualities: C_value[] = [];
  public docType: DocType = DocType.FACTURE; // TICKET = vente comptoir, FACTURE = commande, LOCATION = commande avec rent, AVOIR = avoir. Hyper important : TICKET (comptoir) ⊂ FACTURE (cmd livré) ⊂ LOCATION (cmd livré avec rent_l) où '⊂' représente l'inclusion d'un ensemble
  map_qualities = new Map();
  public resetSearchPartnerSubject: Subject<boolean> = new Subject<boolean>();
  public loadOrderEventsSubject: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(this.formGroup); // To emit load order event
  public loadCustomerEventsSubject: BehaviorSubject<any> = new BehaviorSubject<any | undefined>(null); // To emit customer change event
  public submitEventSubject: Subject<number> = new Subject<number>(); // To emit submit event
  public actionBarState$: BehaviorSubject<ActionBarStatus> = new BehaviorSubject<ActionBarStatus>(new ActionBarStatus(false, false));

  public searchnameClient: String = ''; // Client name value binding

  // FSE Related stuff
  public empreinteCVInserted: EmpreinteCV | undefined; // Empreinte from inserted card
  private area_baseurl?: string = undefined;
  private configarea?: ConfigArea;
  private numIdentFact?: string;
  // Motif de fermeture du geste « Lire carte vitale ». null = geste ouvert ; sinon le texte part tel
  // quel en infobulle sur le bouton grisé. Grisé plutôt que masqué : un bouton disparu se lit comme
  // une panne, alors qu'ici c'est un défaut de PARAMÉTRAGE — et l'infobulle dit lequel.
  public fseBlockedReason: string | null = null;

  xmlparser: Parser = new Parser({ strict: true, trim: false, explicitArray: false });

  public isDistinctBeneficiary: boolean = false;
  public beneficiary: any | undefined;
  public resetSearchBeneficiarySubject: Subject<boolean> = new Subject<boolean>();

  public loginService: LoginService = inject(LoginService);
  //private valuesService: ValuesService = inject(ValuesService);
  //private partnersService: PartnersService = inject(PartnersService);
  private partnerService: PartnerService = inject(PartnerService);
  private salesService: SalesService = inject(SalesService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private spin: SpinnerService = inject(SpinnerService);
  private alertService: AlertService = inject(AlertService);
  public dialog: MatDialog = inject(MatDialog);
  //private fb: FormBuilder = inject(FormBuilder);
  private quotationService: QuotationService = inject(QuotationService);
  private printService: PrintService = inject(PrintService);
  private attachService: AttachService = inject(AttachService);
  private destroyRef = inject(DestroyRef);
  public fseService: FseService = inject(FseService);
  private quotationFseProcessorService: QuotationFseProcessorService = inject(QuotationFseProcessorService);
  public serverStatusService: ServerStatusService = inject(ServerStatusService);
  private commonService: CommonService = inject(CommonService);
  private newSaleService: NewSaleService = inject(NewSaleService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private injector: Injector = inject(Injector);

  // Poste de travail et établissement qui ont CRÉÉ la pièce. /sales/order/:id ne renvoie que l'ID de
  // la station (`station`) : ni son nom, ni le magasin auquel elle appartient. On résout donc par les
  // deux référentiels, chargés une fois à l'ouverture de l'écran (les deux requêtes se terminent —
  // `take(1)` côté service —, forkJoin ne peut pas rester en suspens).
  private stations: Station[] = [];
  private stores: Store[] = [];
  private stationLabelCache: { id: number; label: string } | null = null;

  constructor() {
    //this.area_baseurl=util.getArea_baseurl();	// Get Area server URL from station in localstorage
    const station = this.loginService.currentstation;
    if (station && station.data.hasOwnProperty('configarea')) {
      this.configarea = station.data.configarea;
      this.area_baseurl = this.configarea?.area_baseurl;
    }
    effect(() => {}); // Signal received
  }

  ngOnInit(): void {
    forkJoin({ stations: this.commonService.getStations(), stores: this.commonService.getStores() })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ref => {
          this.stations = ref.stations ?? [];
          this.stores = ref.stores ?? [];
          this.stationLabelCache = null;
        },
        // Référentiel indisponible : la puce reste vide. Ce n'est qu'une information de
        // provenance, elle ne doit jamais bloquer l'ouverture d'une commande.
        error: e => console.error('[QuotationComponent] référentiel postes/magasins indisponible', e),
      });

    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      const paramId = params.get('id');
      const id = paramId === 'commande' || isNaN(Number(paramId)) ? 0 : Number(paramId);
      this.create_or_load_order(id);
      if (id === 0) this.presetCustomerFromUrl();
    });

    this.serverStatusService.isOnline$.pipe(skip(1), takeUntilDestroyed(this.destroyRef)).subscribe(isOnline => {
      // `this.id > 0` et non `!== undefined` : sur un BROUILLON (id 0), create_or_load_order
      // appelle createNewOrder et remplace le formulaire — un simple décrochage de Wi-Fi
      // effaçait donc la saisie en cours, sans la moindre question, en contournant
      // SALES_CONFIRM_DISCARD_DRAFT. Rafraîchir n'a de sens que sur une pièce enregistrée.
      if (isOnline && this.id > 0) {
        this.create_or_load_order(this.id);
      }
    });

    // « Vente Comptoir » (ou F1) alors qu'on EST DÉJÀ en vente comptoir : le routeur ne peut rien
    // pour nous — même route, même objet Route, composant réutilisé, paramMap muet. Le menu passe
    // donc par NewSaleService, qui a déjà posé la question de la confirmation le cas échéant ;
    // il ne reste ici qu'à repartir de zéro.
    // ATTENTION à l'endroit : cette souscription doit vivre dans ngOnInit et pas un cran plus haut.
    // Ce n'est pas un caprice de style — c'est aussi la raison pour laquelle on ne s'appuie PAS sur
    // router.events (cf. new-sale.service.ts).
    this.newSaleService.resetRequests$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(kind => this.resetToNewOrder(NEW_SALE_DOCUMENTS[kind].docType));

    // Le service ne connaît ni le formulaire ni les lignes : c'est l'écran qui lui dit s'il y a
    // quelque chose à perdre. Le retrait est explicite — un composant mort ne doit pas continuer
    // à répondre pour l'écran suivant.
    this.destroyRef.onDestroy(this.newSaleService.registerDraftGuard(() => this.hasUnsavedInput));

    // FSE : le geste carte vitale demande DEUX conditions réunies, la STATION et le COMPTE connecté.
    // Le déclencheur ne regardait que la station (`configarea`) : tout compte dont `c_user.data` ne
    // porte pas de bloc FSE prenait une alerte bloquante à l'ouverture de l'écran — pour une commande
    // qui n'a peut-être aucun rapport avec une feuille de soins. L'identité PS est lue dans le JETON
    // (Claims.data = c_user.data, cf. common/src/user/model.rs côté serveur) : aucun appel réseau, et
    // la valeur est là dès le premier rendu, donc le bouton part grisé sans clignoter. Contrepartie
    // assumée : un compte paramétré APRÈS sa connexion doit se reconnecter pour ouvrir la FSE.
    // Le test reprend celui du service (numSituation ET numIdentFact, fse.service.ts) — plus laxiste
    // ici, on rouvrirait la porte à l'alerte qu'on vient de fermer.
    const ps = this.loginService.loggeduser?.data?.FSE?.PS;
    if (!this.configarea) {
      this.fseBlockedReason = "Cette caisse n'est pas configurée pour la FSE : lecture de carte vitale indisponible";
    } else if (!ps?.numSituation || !ps?.numIdentFact) {
      this.fseBlockedReason = "Vous êtes sur une caisse FSE, mais le compte connecté n'a aucun paramétrage FSE " + '(identité PS absente de sa fiche utilisateur) : lecture de carte vitale indisponible';
    } else {
      this.fseService.getUserWhenReady$().subscribe({
        // Identité confirmée par la base, qui fait foi
        next: user => {
          if (user && user.data?.FSE?.PS?.numIdentFact) {
            this.numIdentFact = user.data.FSE.PS.numIdentFact;
          } else {
            // Le jeton annonçait une identité PS que la base n'a plus : anomalie, pas cas courant.
            this.fseBlockedReason = 'Le paramétrage FSE du compte a disparu depuis la connexion : reconnectez-vous';
            console.error('[QuotationComponent] identité PS dans le jeton, absente de c_user.data');
          }
        },
        error: err => {
          this.fseBlockedReason = 'Paramétrage FSE du compte illisible : ' + err.message;
          console.error('[QuotationComponent] lecture du paramétrage FSE impossible', err);
        },
      });
    }
  }

  // Deal w/ Client name input field => trigger partner lookup
  ngAfterViewInit() {
    // Subscribe on loadOrderEventsSubject to listen to searchNameInput (TODO useless if order is delivered)
    this.loadOrderEventsSubject.subscribe((fg: FormGroup<any>) => {
      if (fg && fg.get('id') != null) return; // BehaviourSubject triggers empty the 1st time
    });
    this.resetSearchPartnerSubject.next(true);
    setTimeout(() => this.checkAndExecutePendingAvoirAction(), 50);

    // Fordev
    // Simuler un clic sur le premier élément avec la classe "partner-link"
    // setTimeout(() => {
    //   const partnerLink = document.querySelector('.partner-link') as HTMLElement;
    //   console.log('partnerLink',partnerLink);
    //   if (partnerLink) {
    //     partnerLink.click();
    //   }
    // }, 300);
  }

  getBenefiaires(_cv: any): Observable<any> {
    return of({});
  }

  create_or_load_order(id: number): void {
    if (id !== this.id) this.closedLinesLoaded = false;
    this.id = id;
    if (this.id === 0) {
      // New order (no URL param)
      this.createNewOrder();
    } else {
      // Existing order => load it!
      this.loadOrder();
      this.fseService.getFses$(`q=orderId:${this.id}`).subscribe({
        // FIXME only if FSE mode is enabled for user
        next: (fseOrder: FSEOrder[]) => {
          if (Array.isArray(fseOrder) && fseOrder.length > 0) this.fseOrders = fseOrder;
        },
        error: _error => {
          this.alertService.error('ERREUR au chargement des FSEs');
        },
      });
    }
  }

  readonly NEW_SALE_DOCUMENTS = NEW_SALE_DOCUMENTS;
  readonly NEW_SALE_KINDS = NEW_SALE_KINDS;

  /** Boutons F1 / F2 / F3 de l'en-tête : pièce enregistrée et client connu. */
  get canOpenNewSale(): boolean {
    return this.id > 0 && Number(this.customer?.id) > 0;
  }

  /** Toujours un nouvel onglet : la pièce consultée reste dans celui-ci. */
  openNewSale(kind: NewSaleKind): void {
    if (this.canOpenNewSale) openSaleForCustomer(this.router, this.alertService, kind, Number(this.customer.id), true);
  }

  /** Saisie neuve ouverte avec ?customer=id (boutons « pour ce client », openSaleForCustomer) : le client arrive choisi, comme pris dans la recherche. */
  private presetCustomerFromUrl(): void {
    const customerId = Number(this.route.snapshot.queryParamMap.get('customer'));
    if (!Number.isInteger(customerId) || customerId <= 0) return;
    const epoch = this.resetEpoch;
    // Retiré de l'URL une fois lu, la navigation initiale finie : un F1 sur place puis F5 ne ressuscite pas ce client.
    const dropParam = () => this.router.navigate([], { relativeTo: this.route, queryParams: { customer: null }, queryParamsHandling: 'merge', replaceUrl: true });
    this.partnerService
      .getPartnerByid(customerId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (partners: any) => {
          dropParam();
          const p = Array.isArray(partners) ? partners[0] : partners;
          if (!p?.id) {
            this.alertService.error(`Client n° ${customerId} introuvable : choisissez-le dans la recherche`);
            return;
          }
          // Repartie à zéro entre-temps, ou client déjà choisi à la main : on n'écrase rien.
          if (epoch !== this.resetEpoch || this.id !== 0 || this.customer || !!this.formGroup.get('customer')?.value) return;
          this.customerChange(p);
        },
        error: err => {
          dropParam();
          console.error('[QuotationComponent] client de la fiche tiers illisible', err);
          this.alertService.error(`Client n° ${customerId} illisible : choisissez-le dans la recherche`);
        },
      });
  }

  /**
   * @param docType type de pièce voulu. Omis, il est relu dans les `data` de la route — ce qui
   *   n'est juste QUE sur /sales/quotation/comptoir|commande|rent. La route `:id` n'en porte
   *   aucun : un appel sans paramètre depuis une pièce ouverte retomberait silencieusement sur
   *   FACTURE. Tout appel hors du cycle de navigation doit donc passer le type explicitement.
   */
  createNewOrder(docType?: DocType): void {
    this.quotationService.pendingAvoirAction = null;
    this.id = 0; // CRITICAL: Reset the local ID
    this.dataOk = true;
    this.dataError = false;
    this.customer = undefined;
    this.isDistinctBeneficiary = false;
    this.beneficiary = undefined;
    this.docType = docType ?? this.route.snapshot.data['docType'] ?? DocType.FACTURE;
    this.childInvoices = [];
    this.formGroup = Sales_order.newOrderFormGroup();
    this.formGroup.get('station')?.patchValue(this.loginService.currentstation?.id ? this.loginService.currentstation.id : null);
    this.formGroup.get('id_user')?.patchValue(this.loginService.loggeduser?.id ? this.loginService.loggeduser?.id : null);
    this.formGroup.get('doc_type')?.patchValue(this.docType);
    if (this.docType === DocType.LOCATION) {
      // Les contrats de loc. naissent en PEPARATION
      this.formGroup.get('state')?.patchValue(SalesOrderState.PREPARATION);
    }
    // Le reste à payer vient de l'enfant, qui ne le recalcule QUE sur une commande enregistrée
    // (id > 0) : sans cette remise à zéro, le document neuf hériterait du reste à payer de la
    // commande précédemment ouverte.
    this.remainder = 0;

    this.eventtyp = EVENTTYP_INSERT; // CREATE mode. Will issue an update event
    this.loadOrderEventsSubject.next(this.formGroup); // Emit a loadorder event to child components
    this.resetSearchPartnerSubject.next(true); // erase all data in search partner and give it the focus
  }

  // ============================================================
  // REPARTIR À ZÉRO SANS CHANGER DE ROUTE
  // ============================================================

  /**
   * Y a-t-il une saisie qu'un effacement ferait PERDRE ? C'est le prédicat que NewSaleService
   * consulte avant de poser (ou non) la question de la confirmation.
   *
   * Une pièce déjà enregistrée (id > 0) ne compte pas : elle est en base, on la retrouve. Seul
   * le brouillon compte, et il n'est « quelque chose » qu'à partir d'un client choisi ou d'une
   * première ligne — sinon l'écran est vierge et la question n'aurait aucun objet.
   */
  get hasUnsavedInput(): boolean {
    if (!this.formGroup || this.id > 0) return false;
    const lines = this.formGroup.get('lines') as FormArray | null;
    // Le contrôle `customer` est testé EN PLUS de `this.customer` : le tunnel FSE rattache
    // l'assuré en écrivant le contrôle et en mettant délibérément `this.customer` à undefined
    // (cf. patchFormGroupCustomer dans openRecipientsDialog). Sans ce second test, une lecture
    // de carte vitale suivie d'un F1 perdait le bénéficiaire sans un mot. Aucun faux positif :
    // le contrôle vaut 0 sur un document neuf et y revient par customerChange(undefined).
    return !!this.customer || !!this.formGroup.get('customer')?.value || (lines?.length ?? 0) > 0;
  }

  /**
   * DÉMONTAGE PUIS REMONTAGE — et non un simple `createNewOrder()`.
   *
   * Un nouveau FormGroup poussé dans loadOrderEventsSubject ne nettoie que ce qui EST le
   * formulaire. Tout ce que les composants enfants gardent à côté survivrait, et pas seulement
   * des broutilles d'affichage : `linetype` de quotationgeneral, par exemple, reste sur « Retour
   * Article » ou « Rabais » si la vente précédente s'y était mise — et la vente SUIVANTE saisirait
   * ses articles dans ce type-là. Idem pour la saisie de règlement, les compteurs d'articles, le
   * reste à payer, et le texte encore présent dans la recherche produit, qui repart au prochain
   * blur. Repartir « à zéro » veut dire ce qu'il dit : on jette les instances.
   *
   * C'est exactement ce que le routeur fait déjà quand on passe d'un type de document à un autre
   * (routes distinctes ⇒ composant détruit puis recréé). On reproduit ce comportement, sur place.
   *
   * Les deux `detectChanges()` ne sont pas décoratifs : sans le premier, Angular verrait
   * `mounted` repasser à true avant d'avoir appliqué le false et ne démonterait jamais rien.
   * Les faire à la suite, dans le même tour, évite aussi l'image blanche d'une frame que laisserait
   * un setTimeout.
   */
  resetToNewOrder(docType?: DocType): void {
    this.resetEpoch++; // invalide tout ce qui était parti pour le document précédent
    this.mounted = false;
    this.cdr.detectChanges(); // le démontage doit être EFFECTIF avant tout le reste

    // Remises à zéro que createNewOrder ne fait pas, parce qu'à sa création le composant naissait
    // toujours neuf : il n'avait jamais rien à effacer.
    this.fseOrders = []; // FSE de la pièce précédente — elles ne concernent pas celle-ci
    this.NoDocumentError = false;
    this.selectedtab = 0;
    this.sideTab = 0;
    this.sideTabFor = -1;
    this.is_ht = false; // dérivé du client (cuf PARTNER_IS_HT) : sans client, valeur par défaut
    this.group_packagings = true; // réglage d'affichage, remis à son défaut — c'est déjà ce que
    // fait un changement de type de document, qui recrée le composant
    this.empreinteCVInserted = undefined;
    this.actionBarState$.next(new ActionBarStatus(false, false));
    // Pendant que plus personne n'écoute : ce BehaviorSubject retient le dernier client, et on ne
    // veut pas qu'il le rejoue aux enfants qui vont naître.
    this.loadCustomerEventsSubject.next(undefined);

    this.createNewOrder(docType);

    this.mounted = true;
    this.cdr.detectChanges(); // enfants neufs ; ils lisent le formGroup courant du BehaviorSubject
    // Après le remontage seulement : le champ « Client » existe de nouveau, et c'est cet appel
    // qui lui rend le FOCUS — au comptoir, la vente suivante commence par le nom du client.
    this.resetSearchPartnerSubject.next(true);
    this.resetSearchBeneficiarySubject.next(true);
  }

  // Lignes closes d'un contrat de location (matériel repris, reprise signée) : non lues tant que l'on ne les demande pas (o=open).
  public closedLinesLoaded = false;

  loadClosedLines(): void {
    this.closedLinesLoaded = true;
    this.loadOrder();
  }

  loadOrder(cb?: () => void) {
    this.dataOk = false;
    this.NoDocumentError = false; // un id inconnu puis un id valide dans le même composant : le message ne doit pas rester
    this.childInvoices = [];
    this.quotationService
      .getQuotationAsFormGroup(this.id, this.closedLinesLoaded ? '' : '?o=open')
      .pipe(
        switchMap((formgroup: FormGroup<SalesOrderForm> | undefined) => {
          if (!formgroup) {
            return of({ formgroup: undefined, childInvoices: [] as Sales_order[] });
          }
          const docType = formgroup.get('doc_type')?.value as DocType;
          const isParentLocation = docType === DocType.LOCATION && !formgroup.get('data')?.value?.parent_order_id;
          if (docType === DocType.LOCATION && this.id) {
            const childOrders$ = this.quotationService.getChildOrders(this.id).pipe(
              catchError(err => {
                console.error('[QuotationComponent] Erreur au chargement des factures enfants', err);
                return of([] as Sales_order[]);
              }),
            );

            const deliveries$ = isParentLocation
              ? this.quotationService.getQuotationById(this.id, this.closedLinesLoaded ? '?o=deliveries' : '?o=deliveries,open').pipe(
                  map((orders: Sales_order[]) => (orders?.[0]?.lnk_deliveries ?? []) as Delivery[]),
                  catchError(err => {
                    console.error('[QuotationComponent] Erreur au chargement des livraisons de location', err);
                    return of([] as Delivery[]);
                  }),
                )
              : of([] as Delivery[]);

            return forkJoin({ childOrders: childOrders$, deliveries: deliveries$ }).pipe(
              map(({ childOrders, deliveries }) => {
                if (deliveries && deliveries.length > 0) {
                  const delArray = formgroup.get('lnk_deliveries') as FormArray;
                  if (delArray) {
                    delArray.clear();
                    deliveries.forEach(d => delArray.push(Delivery.asFormGroup(d)));
                  }
                }
                return {
                  formgroup,
                  childInvoices: Array.isArray(childOrders) ? childOrders.sort((a, b) => a.id - b.id) : [],
                };
              }),
            );
          }
          return of({ formgroup, childInvoices: [] as Sales_order[] });
        }),
        takeUntilDestroyed(this.destroyRef),
        this.spin.block('Chargement de la commande…'),
      )
      .subscribe({
        next: ({ formgroup, childInvoices }) => {
          this.childInvoices = childInvoices;
          if (!formgroup) {
            this.dataOk = false;
            this.NoDocumentError = true;
            return;
          }
          this.dataOk = true;
          this.dataError = false;

          this.formGroup = formgroup;
          this.customer = formgroup.get('lnk_customer')?.value;
          if (formgroup.get('doc_type')?.value) {
            this.docType = formgroup.get('doc_type')?.value as DocType;
          }

          console.log('this.customer', this.customer);
          if (this.customer?.data?.cufs?.[cufSystem.PARTNER_IS_HT]) {
            this.is_ht = this.customer.data.cufs[cufSystem.PARTNER_IS_HT];
          }
          const orderData = formgroup.get('data')?.value;
          const beneficiaireId = orderData?.recipient;
          if (beneficiaireId) {
            this.isDistinctBeneficiary = true;
            this.partnerService
              .getPartnerByid(beneficiaireId)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe({
                next: (partners: any) => {
                  const ben = Array.isArray(partners) ? partners[0] : partners;
                  this.beneficiary = ben;
                  if (Partner.addresses(this.beneficiary).length && this.canEditHeader) {
                    this.formGroup.get('addr_deliv')?.enable();
                  } else {
                    this.formGroup.get('addr_deliv')?.disable();
                  }
                },
                error: err => console.error('[QuotationComponent] Erreur chargement tiers bénéficiaire', err),
              });
          } else {
            this.isDistinctBeneficiary = false;
            this.beneficiary = undefined;
          }

          if (Partner.addresses(this.customer).length && this.canEditHeader) {
            this.formGroup.get('addr_bill')?.enable();
            if (!this.isDistinctBeneficiary) {
              this.formGroup.get('addr_deliv')?.enable();
            }
          } else {
            this.formGroup.get('addr_bill')?.disable();
            if (!this.isDistinctBeneficiary) {
              this.formGroup.get('addr_deliv')?.disable();
            }
          }
          this.eventtyp = EVENTTYP_UPDATE; // Update mode. Will issue an update event
          // Onglet posé quand la pièce CHANGE seulement : un rechargement (enregistrement, signature) garde le choix fait à la main.
          if (this.sideTabFor !== this.id) {
            this.sideTab = this.historyByDefault ? 0 : 1;
            this.sideTabFor = this.id;
          }
          this.loadOrderEventsSubject.next(this.formGroup); // Emit a loadorder event to child components
          // Après le rendu : au premier chargement les enfants naissent au rendu suivant, et c'est là qu'ils recalculent les montants.
          afterNextRender(() => (this.savedSnapshot = this.formSnapshot()), { injector: this.injector });
          setTimeout(() => this.checkAndExecutePendingAvoirAction(), 50);
          if (cb) cb();
        },
        error: err => {
          this.dataOk = false;
          // 404 = id inconnu (GET /sales/order/{id} rend ErrorNotFound) : « Document inexistant », pas la page blanche de dataError.
          if (err?.status === 404) {
            this.NoDocumentError = true;
          } else {
            this.dataError = true;
          }
          console.error('Error loading quotation', err);
        },
      });
  }

  // onRefused : appelé quand l'enregistrement est refusé avant tout envoi (garde, clôture, question déclinée).
  onSubmit(cb?: Function, onRefused?: () => void) {
    // Garde AMONT du mode consultation : une pièce reprise ne doit même pas consommer un
    // appel getPeriods. _executeSubmit porte la même garde — celle-ci évite juste l'aller-
    // retour réseau, celle-là est le vrai goulot d'étranglement (cf. _executeSubmit).
    if (this.isReadOnly) {
      this.quotationService.pendingAvoirAction = null; // chaque refus avant envoi efface l'action d'avoir : sinon elle partirait au chargement suivant
      onRefused?.();
      return;
    }
    // Client et adresse exigés sur un contrat de location (sauf en cas d'annulation CANCELED).
    const isCanceling = this.formGroup?.controls.state.value === SalesOrderState.CANCELED;
    const blocked = !isCanceling ? this.orderBlockedReason : null;
    if (blocked) {
      this.alertService.warn(blocked);
      this.quotationService.pendingAvoirAction = null;
      onRefused?.();
      return;
    }
    // L'overlay fige l'écran, pas le clavier : sans cette garde la touche Entrée (ngSubmit)
    // relancerait un enregistrement par-dessus celui qui est déjà en vol.
    if (this.spin.isLoading) {
      console.warn('[QuotationComponent] enregistrement ignoré : une opération est déjà en cours');
      onRefused?.();
      return;
    }
    // L'époque du document qu'on a l'intention d'enregistrer, figée AVANT le premier aller-retour
    // réseau. Entre ce getPeriods (et l'éventuelle question de clôture qui le suit) et l'écriture
    // réelle, il s'écoule assez de temps pour qu'un F1 remette l'écran à zéro : voir la garde en
    // tête de _executeSubmit, qui refuse alors d'enregistrer le formulaire d'un AUTRE document.
    const epoch = this.resetEpoch;
    // Écran figé dès le clic ; chaque branche fait EXACTEMENT un hide : avant toute Swal (l'overlay la recouvrirait) ou après _executeSubmit, qui a pris le relais.
    this.spin.show('Enregistrement de la commande…');
    this.salesService.getPeriods().subscribe({
      next: (response: any) => {
        if (response && response.success && response.data && response.data.length === 3) {
          const dayPeriodData = response.data[2];
          if (dayPeriodData && dayPeriodData.status === 'open') {
            const now = Date.now();
            const end = new Date(dayPeriodData.end_date).getTime();
            const hardLimit = periodHardLimit(dayPeriodData.end_date, dayPeriodData.z_report_hard_limit_date);

            if (now >= hardLimit) {
              this.spin.hide();
              Swal.fire({
                title: 'Clôture obligatoire',
                text: `La session de caisse a dépassé ${periodLimitPhrase(dayPeriodData.end_date, dayPeriodData.z_report_hard_limit_date)}. Vous devez effectuer un Z de caisse.`,
                icon: 'error',
                confirmButtonText: 'Compris',
              });
              this.quotationService.pendingAvoirAction = null;
              onRefused?.();
              return; // Abort submission
            }

            if (now >= end) {
              this.spin.hide();
              Swal.fire({
                title: 'Attention',
                text: 'La fin théorique de la période est dépassée. Il est conseillé de clôturer la caisse. Voulez-vous quand même continuer ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, continuer',
                cancelButtonText: 'Annuler',
              }).then(result => {
                if (result.isConfirmed) {
                  this._executeSubmit(cb, epoch);
                } else {
                  this.quotationService.pendingAvoirAction = null;
                  onRefused?.();
                }
              });
              return; // Abort immediate submission, wait for confirmation
            }
          }
        }
        this._executeSubmit(cb, epoch);
        this.spin.hide();
      },
      error: e => {
        console.error('Could not fetch periods for JIT verification', e);
        this._executeSubmit(cb, epoch); // Fallback to server-side enforcement
        this.spin.hide();
      },
    });
  }

  private _executeSubmit(cb?: Function, epoch: number = this.resetEpoch) {
    // L'écran a été remis à zéro depuis que cette écriture a été demandée : `this.formGroup` n'est
    // plus le document qu'on voulait enregistrer, c'est le document VIERGE qui l'a remplacé.
    // Poursuivre créerait en base une pièce sans client ni ligne — plus, sur un ticket, une
    // livraison comptoir fantôme — puis arracherait l'utilisateur à sa vente neuve pour l'amener
    // dessus. On abandonne : la vente d'origine n'est pas enregistrée, mais elle a été effacée à
    // la demande expresse de l'utilisateur (confirmation comprise, cf. SALES_CONFIRM_DISCARD_DRAFT).
    if (epoch !== this.resetEpoch) {
      console.warn('[QuotationComponent] enregistrement abandonné : le document a été remis à zéro entre-temps');
      return;
    }
    // GOULOT D'ÉTRANGLEMENT : toutes les voies d'écriture de l'écran passent ici — bouton
    // « Enregistrer » de la barre d'action, touche Entrée dans le formulaire (ngSubmit),
    // remontées (onSubmit) des composants enfants, et tunnel FSE via QuotationFseActions.
    // Une seule garde ferme donc tout, y compris les chemins qu'aucun *ngIf ne couvre.
    if (this.isReadOnly) {
      this.alertService.warn("Document repris de l'ancien logiciel : consultation seule, aucune modification n'est enregistrable.");
      this.quotationService.pendingAvoirAction = null;
      return;
    }
    this.submitEventSubject.next(this.selectedtab); // Emit a submit event to child components  // why jpc ?
    if (this.selectedtab !== 0) {
      this.quotationService.pendingAvoirAction = null; // rien n'est envoyé : l'action d'avoir ne doit pas survivre
      return; // FIXME Save only on tab 0
    }
    if (this.customer) this.formGroup.get('customer')?.setValue(this.customer.id);

    const addrDeliv = this.formGroup.get('addr_deliv')?.value;
    const addrBill = this.formGroup.get('addr_bill')?.value;
    const currentStore = this.loginService.currentstore;
    this.formGroup.patchValue({
      // Use patchValue for multiple fields to trigger only one update event
      addr_deliv: addrDeliv ? Number(addrDeliv) : 0, // O is the unidentified c_partner. FIXME Won't work as it is disabled
      addr_bill: addrBill ? Number(addrBill) : 0,
      store: currentStore ?? 0,
    });

    const wasBillDisabled = this.formGroup.get('addr_bill')?.disabled; // Force addr_bill to be submitted even if it's disabled
    if (wasBillDisabled) this.formGroup.get('addr_bill')?.enable({ emitEvent: false }); // loadOrder will reset it's **enabled state**
    const wasDelivDisabled = this.formGroup.get('addr_deliv')?.disabled;
    if (wasDelivDisabled) this.formGroup.get('addr_deliv')?.enable({ emitEvent: false });

    const currentData = this.formGroup.get('data')?.value || {};
    if (this.isDistinctBeneficiary && this.beneficiary?.id) {
      this.formGroup.get('data')?.patchValue({ ...currentData, recipient: this.beneficiary.id });
    } else if (!this.isDistinctBeneficiary && currentData.recipient) {
      const { recipient, ...restData } = currentData;
      this.formGroup.get('data')?.setValue(restData);
    }

    // console.log("[quotationComponent] OnSubmit: " + JSON.stringify(this.formGroup.value, null, 2));
    const saleLines = this.takeRentalSaleLines();
    this.quotationService
      .postQuotationEvent(this.eventtyp, this.formGroup)
      .pipe(this.spin.block('Enregistrement de la commande…'))
      .subscribe({
        next: async (response: ApiResponse) => {
          console.log('Server response: ' + JSON.stringify(response));
          if (!response || !response.success) {
            this.quotationService.pendingAvoirAction = null;
            const serverMsg = response?.msg || response?.error_msg || 'Erreur inconnue';
            utils.showError(`La commande n'a pas été enregistré.\nDétails: ${serverMsg}`, 'ERREUR Serveur');
            console.error(response);
            if (epoch === this.resetEpoch) this.create_or_load_order(this.id); // sinon on rechargerait par-dessus le document neuf
            return;
          }
          const newId = response.data.order_id;
          if (!this.quotationService.pendingAvoirAction) {
            this.alertService.success('Enregistrement OK: ' + formatNumber(newId, 'fr', '1.0-0'));
          }
          if (saleLines.length) await this.placeRentalSales(Number(newId), saleLines);
          // Cas d'une remise à zéro survenue pendant que le POST était en vol : la pièce est bien
          // enregistrée (les données envoyées étaient les bonnes) et le message ci-dessus le dit,
          // mais on ne recharge ni ne navigue — l'utilisateur a demandé un document neuf, il y reste.
          if (epoch !== this.resetEpoch) {
            this.quotationService.pendingAvoirAction = null;
            console.warn('[QuotationComponent] commande ' + newId + " enregistrée, mais l'écran a été remis à zéro : on n'y navigue pas");
          } else if (this.id === newId) {
            // Same order id
            this.loadOrder(() => {
              if (typeof cb !== 'undefined') cb(response.data.order_id);
            });
          } else {
            // Brouillon enregistré : l'action d'avoir posée sur lui suit la pièce sous l'id que le serveur vient de lui donner.
            if (this.quotationService.pendingAvoirOrderId === this.id) this.quotationService.pendingAvoirOrderId = newId;
            // Relais TENU jusqu'à la fin de la navigation : le composant neuf est créé pendant celle-ci
            // et son loadOrder rallume l'overlay avant ce hide — sans ce show, l'écran clignoterait vide.
            this.spin.show();
            this.router.navigate(['/sales/quotation', newId]).finally(() => this.spin.hide());
            if (typeof cb !== 'undefined') cb(response.data.order_id);
          }
        },
        error: e => {
          this.quotationService.pendingAvoirAction = null;
          const serverMsg = e.error?.message || e.error || e.message || 'Erreur inconnue';
          utils.showError(`La bon n'a pas été enregistré.\nDétails: ${serverMsg}`, 'ERREUR Serveur');
          console.error(e.error);
          if (epoch === this.resetEpoch) this.create_or_load_order(this.id); // Something went wrong => ROLLBACK = reload Order as it is on server
          // (sauf si l'écran a été remis à zéro : le rollback écraserait le document neuf)
        },
      });
  }

  // Audit 31/10 #31 : un dossier LOCATION ne porte que le loué ; ses ventes neuves (produits liés, composants d'un configurable) sont retirées de l'envoi
  // et partent, une fois le dossier enregistré, dans sa commande de vente (même mécanique que la page du dossier, rental-sale-order.ts).
  private takeRentalSaleLines(): FormGroup[] {
    if (this.formGroup.get('doc_type')?.value !== DocType.LOCATION) return [];
    const lines = this.formGroup.get('lines') as FormArray;
    const taken: FormGroup[] = [];
    for (let i = lines.length - 1; i >= 0; i--) {
      const l = lines.at(i) as FormGroup;
      const typ = l.get('typ')?.value;
      if ((Number(l.get('id')?.value) || 0) > 0 || typ === OrderLineType.RENTAL || typ === OrderLineType.RENTAL_RETURN) continue;
      lines.removeAt(i);
      for (const k of ['rental_terms_snapshot', 'rental_lifecycle']) if (l.contains(k)) l.removeControl(k);   // une commande de vente ne loue rien
      taken.unshift(l);
    }
    return taken;
  }

  // F2 en création du dossier complétée, sinon une neuve, validée au passage qui la livre ; un refus propose « Réessayer » plutôt que de perdre les articles.
  private async placeRentalSales(dossierId: number, lines: FormGroup[]): Promise<void> {
    const label = 'Commande de vente du dossier…';
    const api: SaleOrderApi = {
      list: (id) => this.quotationService.getRentalSaleOrders(id).pipe(this.spin.block(label)),
      read: (id) => this.quotationService.getQuotationAsFormGroup(id).pipe(this.spin.block(label)),
      post: (typ, fg) => this.quotationService.postQuotationEvent(typ, fg).pipe(this.spin.block(label)),
    };
    const head = saleOrderHeadOf(this.formGroup.getRawValue(), dossierId);
    const names = lines.map((l) => l.get('product_name')?.value).join(', ');
    for (;;) {
      try {
        const id = await placeSaleLines(api, head, this.loginService.loggeduser?.id ?? null, this.loginService.currentstore ?? null, lines);
        this.alertService.success(`Commande de vente n° ${id} du dossier ${dossierId} : ${names}`);
        return;
      } catch (e) {
        const why = e instanceof Error ? e.message : (e as any)?.error?.message || (e as any)?.message || 'Erreur inconnue';
        const r = await Swal.fire({ titleText: 'Commande de vente non enregistrée', icon: 'error', showCancelButton: true, confirmButtonText: 'Réessayer', cancelButtonText: 'Abandonner ces articles',
          text: `Le dossier n° ${dossierId} est enregistré, mais ses articles vendus (${names}) n'ont pas pu entrer dans sa commande de vente : ${why}` });
        if (!r.isConfirmed) { this.alertService.warn('Articles vendus abandonnés : ajoutez-les par « Vendre un article » sur la page du dossier'); return; }
      }
    }
  }

  onActionBarSubmit(formName: String) {
    console.log('onActionBarSubmit [form/tab]: ' + formName + '/' + this.selectedtab);
    if (!this.canSave) {
      this.alertService.warn("Cette commande n'est pas modifiable dans son état actuel.");
      return;
    }
    this.onSubmit(() => {});
  }

  onFormSubmit() {
    if (!this.canSave) {
      this.alertService.warn("Cette commande n'est pas modifiable dans son état actuel.");
      return;
    }
    this.onSubmit();
  }

  onActionBarAction(action: String) {
    console.log('onActionBarAction: ' + action);
    // Aucune action n'est légitime sur une pièce reprise (transitions refusées par le serveur, livraison = écriture, montants non déduits des lignes pour PRINT/SIGN).
    // Garde sur l'AIGUILLAGE et non sur les boutons : seul endroit qui couvre aussi le tunnel FSE (QuotationFseActions.triggerActionBarAction).
    if (this.isReadOnly) return;
    switch (action) {
      case 'PRINT': {
        // Imprimer et faire signer : la pièce vient de l'état (tradeDocFor), la même pour les deux gestes.
        const doc = this.currentTradeDoc();
        if (doc) this.printDocument(doc);
        break;
      }

      case 'SIGN': {
        const doc = this.currentTradeDoc();
        if (doc) this.signDocument(doc);
        break;
      }

      // Réimpression du devis accepté, à côté du bon de commande (PREPARATION, DELIVERED) : arbitrage JP du 29/09/2026.
      case 'PRINT_DEVIS':
        this.printDocument('devis');
        break;

      case 'PRINT_TICKET_A4':
        this.printJustificatif(action);
        break;

      case 'PRINT_INVOICE_A4':
        this.printJustificatif(action);
        break;

      case SalesOrderAction.DEVALIDATE:
        if (this.docType === DocType.LOCATION) {
          this.alertService.warn('Un contrat de location ne peut pas être dévalidé.');
          return;
        }
        this.submitState(SalesOrderState.CREATED); // Back to created state
        break;

      case SalesOrderAction.QUOTE:
        this.submitState(SalesOrderState.QUOTE);
        break;

      case SalesOrderAction.PREPARATION:
        this.submitState(SalesOrderState.PREPARATION);
        break;

      case 'REFUND_CASH': {
        const general = this.quotationGeneral();
        if (general) {
          general.onRefundCash();
        }
        break;
      }

      case 'AVOIR_ONLY': {
        const general = this.quotationGeneral();
        if (general) {
          general.onEmitAvoirOnly();
        }
        break;
      }

      case SalesOrderAction.VALIDATE:
        if (Number(this.formGroup.get('amount_taxi')?.value || 0) < 0) {
          if (this.formGroup?.get('doc_type')?.value === DocType.FACTURE) {
            this.alertService.warn('Une commande à livrer ne peut avoir un montant négatif. Passer un avoir en comptoir');
            return;
          }
          this.alertService.warn('Un document au montant négatif nécessite un choix explicite (Remboursement espèces ou Avoir uniquement).');
          return;
        }
        this.submitState(SalesOrderState.PREPARATION);
        break;

      case SalesOrderAction.DELIVER:
        // Back-stop du grisage : le tunnel FSE entre ici sans passer par le bouton.
        if (this.deliveryBlockedReason) {
          this.alertService.warn(this.deliveryBlockedReason);
          return;
        }
        if (this.mustSaveBeforeDoc) {
          this.onSubmit((orderId: number) => this.openDeliveryDialog());
        } else {
          this.openDeliveryDialog();
        }
        break;
      case SalesOrderAction.TAKE_DEPOSIT:
        this.openDepositDialog();
        break;
      case 'APPLY_AVOIR':
        this.openUseAvoirDialog();
        break;
      case SalesOrderAction.CANCEL:
        if (this.id === 0) {
          // Brouillon non persisté : abandonner et réinitialiser l'écran
          this.resetToNewOrder(this.docType);
          this.alertService.info('Brouillon abandonné.');
          return;
        }
        // Back-stop du grisage : une facture de location ne s'annule pas ici, le serveur le refuserait (409).
        if (this.isRentalInvoice) {
          this.alertService.warn(RENTAL_INVOICE_NO_MANUAL_CREDIT);
          return;
        }
        this.submitState(SalesOrderState.CANCELED); // Cancel transaction => CANCELED (Final)
        break;

      default:
        console.error('[onActionBarAction] Unknown action');
    }
  }

  /**
   * Enchaîne automatiquement la deuxième étape de l'action d'avoir après la création des créances en PREPARATION :
   * - AVOIR_ONLY : validation scellée de l'Avoir sans décaissement (INVOICED)
   * - REFUND_CASH : décaissement immédiat en espèces et clôture de l'Avoir (PAID)
   */
  private checkAndExecutePendingAvoirAction(): void {
    // Jamais relancée depuis data.refund_mode : un refus serveur de la 2e étape la relançait à chaque rechargement, sans fin.
    const pending = this.quotationService.pendingAvoirAction;
    if (!pending) return;
    // Pièce pas encore chargée (ngAfterViewInit avant la réponse de loadOrder) : ni exécution ni effacement.
    const loadedId = Number(this.formGroup?.get('id')?.value || 0);
    if (!this.dataOk || loadedId <= 0) return;
    // Seulement sur la pièce où l'action a été demandée, revenue en préparation avec un total négatif : toute autre pièce l'efface.
    if (loadedId !== this.quotationService.pendingAvoirOrderId || this.formGroup.value.state !== SalesOrderState.PREPARATION || !(Number(this.formGroup.get('amount_taxi')?.value || 0) < 0)) {
      this.quotationService.pendingAvoirAction = null;
      return;
    }
    const general = this.quotationGeneral();
    if (!general || !this.formGroup) return;
    const lnk_receivables = this.formGroup.get('lnk_receivables') as FormArray;
    const customerRecCtrl = lnk_receivables?.controls?.find(c => (c.value?.payer_id || 0) === (this.formGroup.value?.customer || 0)) ?? lnk_receivables?.at(0);
    if (!customerRecCtrl) return;

    if (this.spin.isLoading) {
      setTimeout(() => this.checkAndExecutePendingAvoirAction(), 100);
      return;
    }

    if (pending === 'AVOIR_ONLY') {
      general.onEmitAvoirOnly();
    } else if (pending === 'REFUND_CASH') {
      general.onRefundCash();
    }
  }

  // Garde AVANT le patch, état rétabli si onSubmit refuse ensuite : l'écran ne montre jamais un état que le serveur n'a pas.
  private submitState(state: SalesOrderState): void {
    if (state !== SalesOrderState.CANCELED) {
      const blocked = this.orderBlockedReason;
      if (blocked) {
        this.alertService.warn(blocked);
        return;
      }
    }
    if (this.spin.isLoading) {
      console.warn("[QuotationComponent] changement d'état ignoré : une opération est déjà en cours");
      return;
    }
    const fg = this.formGroup; // formulaire d'origine : après une remise à zéro, le rétablissement ne touche pas le document neuf
    const previous = fg.controls.state.value;
    fg.patchValue({ state });
    this.onSubmit(
      () => {},
      () => fg.patchValue({ state: previous }),
    );
  }

  // Le bouton est masqué sans pièce ; l'alerte couvre le tunnel FSE, qui entre par l'aiguillage.
  private currentTradeDoc(): TradeDoc | null {
    const doc = tradeDocFor(this.formGroup.get('state')?.value);
    if (!doc) this.alertService.warn("Une pièce annulée ou refusée n'a ni devis ni bon de commande à imprimer ou à faire signer");
    return doc;
  }

  private formSnapshot(): string {
    return JSON.stringify(this.formGroup?.getRawValue() ?? null);
  }

  // Enregistrer avant d'imprimer ou de faire signer ? Pas là où le serveur n'écrirait rien de l'en-tête (PAID) ou refuserait (INVOICED).
  private get mustSaveBeforeDoc(): boolean {
    if (this.id === 0) return true;
    const state = getStateEnum(this.formGroup?.get('state')?.value);
    const savable = [SalesOrderState.CREATED, SalesOrderState.QUOTE, SalesOrderState.PREPARATION, SalesOrderState.DELIVERED];
    if (this.isReadOnly || !state || !savable.includes(state)) return false;
    return this.formGroup.dirty || this.formSnapshot() !== this.savedSnapshot;
  }

  // Rien de scellé ; un DEVIS imprimé est rangé sur la commande par le serveur (print.rs). La saisie en cours est enregistrée d'abord, le PDF sortant de l'état du serveur.
  private printDocument(doc: TradeDoc) {
    const libelle = doc === 'devis' ? 'Devis' : 'Bon de commande';
    const lancer = (orderId: number) => {
      if (!orderId) {
        this.alertService.warn("Le document doit être enregistré avant d'être imprimé");
        return;
      }
      this.printService
        .getOrderDoc$(orderId, doc)
        .pipe(this.spin.block(libelle + '…'))
        .subscribe({
          next: (blob: Blob) => this.printService.printPdf(blob),
          // `responseType: 'blob'` vaut aussi pour le corps d'erreur : sans le relire, on n'afficherait que « Http failure response ».
          error: async e => {
            let serverMsg = e.message || 'Erreur inconnue';
            if (e.error instanceof Blob) {
              try {
                serverMsg = (await e.error.text()) || serverMsg;
              } catch {
                /* corps illisible */
              }
            } else if (e.error) {
              serverMsg = e.error.message || e.error;
            }
            utils.showError(`L'impression du ${libelle.toLowerCase()} a échoué.\nDétails: ${serverMsg}`, 'ERREUR Impression');
          },
        });
    };

    // Pièce neuve : l'impression part de l'instance quittée, mais elle ne dépend que de PrintService.
    if (this.mustSaveBeforeDoc) this.onSubmit((orderId: number) => lancer(orderId ?? this.id));
    else lancer(this.id);
  }

  // Commande soldée : rien à enregistrer d'abord (PAID), le serveur rend le ticket scellé et compte chaque appel au JET.
  private printJustificatif(formatImpression: String) {
    if (!this.id) return;
    this.printService
      .getOrderJustificatif$(this.id, formatImpression)
      .pipe(this.spin.block('Génération...'))
      .subscribe({
        next: (blob: Blob) => this.printService.printPdf(blob),
        // Corps d'erreur en Blob lui aussi (responseType: 'blob'), comme dans printDocument.
        error: async e => {
          const serverMsg = e.error instanceof Blob ? await e.error.text().catch(() => '') : e.error?.message || e.error;
          utils.showError(`L'impression du justificatif a échoué.\nDétails: ${serverMsg || e.message || 'Erreur inconnue'}`, 'ERREUR Impression');
        },
      });
  }

  // Signature à l'écran comme un BL, après enregistrement ; le PDF signé est rangé sur la commande (doc front.sales.signature-devis-bon-commande).
  private signDocument(doc: TradeDoc) {
    // Pièce neuve : la navigation vers son id détruit ce composant, le retour du dialog serait perdu.
    if (this.id === 0) {
      this.alertService.warn("Enregistrez d'abord la pièce, puis faites-la signer");
      return;
    }
    const libelle = doc === 'devis' ? 'devis' : 'bon de commande';
    const ouvrir = (orderId: number) => {
      if (!orderId) {
        this.alertService.warn("Le document doit être enregistré avant d'être signé");
        return;
      }
      this.dialog
        .open(SignDocDialogComponent, {
          width: '1400px',
          maxWidth: '96vw',
          data: { orderId, doc, customerLabel: `${this.customer?.firstname ?? ''} ${this.customer?.name ?? ''}`.trim() },
        })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          if (result) {
            this.alertService.success('Le ' + libelle + ' signé est rangé dans les documents de la commande');
            this.sideTab = 1; // on montre la pièce signée
            this.loadOrder();
          }
        });
    };

    if (this.mustSaveBeforeDoc) this.onSubmit((orderId: number) => ouvrir(orderId ?? this.id));
    else ouvrir(this.id);
  }

  get depositInfo(): { order_id: number; doc_ref?: string; amount?: number; c_attach_id?: number } | null {
    const data = this.formGroup?.get('data')?.value || this.formGroup?.value?.data;
    if (data?.deposit_order_id) {
      return {
        order_id: data.deposit_order_id,
        doc_ref: data.deposit_doc_ref,
        amount: data.deposit_amount,
        c_attach_id: data.deposit_c_attach_id,
      };
    }
    return null;
  }

  /**
   * Référence de pièce scellée (ex: TK-3214, FAC-25, AV-33) stockée dans sales_order.data.
   */
  get docRef(): string | null {
    const data = this.formGroup?.get('data')?.value || this.formGroup?.value?.data;
    return data?.doc_ref ?? null;
  }

  viewDepositPdf(attachId: number) {
    if (attachId) {
      this.attachService.openInNewTab(attachId);
    }
  }

  openDepositDialog() {
    const dialogRef = this.dialog.open(TakeDepositDialogComponent, {
      width: '580px',
      maxWidth: '95vw',
      data: {
        orderId: this.id,
        remainder: this.remainder,
        amount_taxi: this.formGroup.get('amount_taxi')?.value,
        lines: this.formGroup.get('lines')?.value,
        tax: this.formGroup.get('tax')?.value,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          this.loadOrder();
        }
      });
  }

  openUseAvoirDialog() {
    if (!this.id || this.id <= 0) {
      this.alertService.warn("Veuillez d'abord enregistrer et valider la commande avant d'imputer un avoir.");
      return;
    }
    const customerId = Number(this.formGroup?.get('customer')?.value || 0);
    const customerName = this.customer ? `${this.customer.firstname ?? ''} ${this.customer.name ?? ''}`.trim() : '';
    const dialogRef = this.dialog.open(UseAvoirDialogComponent, {
      width: '680px',
      maxWidth: '95vw',
      data: {
        orderId: this.id,
        customerId,
        customerName: customerName || undefined,
        remainder: this.remainder,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          this.loadOrder();
        }
      });
  }

  // `index` = rang du BL cliqué dans lnk_deliveries (même ORDER BY del.id que la modale) ; absent depuis la barre d'action, la modale choisit alors.
  openDeliveryDialog(index?: number) {
    // Contrat de location (F3) : fenêtre de livraison location (décision de JP du 29/10/2026) ; lnk_deliveries y est lu avec le même filtre que les documents.
    if ((this.formGroup?.get('doc_type')?.value || this.docType) === DocType.LOCATION) {
      const deliveryId = index != null ? Number(this.formGroup?.get(['lnk_deliveries', index, 'id'])?.value) || undefined : undefined;
      this.dialog.open(RentalDeliveryDialogComponent, { width: '90%', height: '90%', maxWidth: '95vw', data: { id: this.id, deliveryId } })
        .afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.loadOrder());
      return;
    }
    const dialogRef = this.dialog.open(DeliveryComponent, {
      width: '90%',
      height: '90%',
      maxWidth: '95vw',
      data: { id: this.id, index },
    });

    // Capture l'état avant la destruction de l'instance du composant (couvre aussi la fermeture par Échap ou clic hors modale)
    let immediateDeliveryIssued = false;
    dialogRef
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        immediateDeliveryIssued = dialogRef.componentInstance?.immediateDeliveryIssued ?? false;
      });

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        // Une livraison immédiate a été validée (signature/validation effective du BL) :
        // passage à « Livré » seulement depuis « En préparation », et jamais pour un contrat de location.
        const wasImmediate = result?.immediateDelivery || immediateDeliveryIssued;
        if (wasImmediate) {
          // 1. Recharger les données fraîches de la commande depuis le serveur (BL créés/mis à jour)
          this.loadOrder(() => {
            // 2. Différer la transition d'un tick pour laisser le finalize de l'overlay de loadOrder se libérer
            setTimeout(() => {
              const state = this.formGroup?.get('state')?.value;
              const docType = this.formGroup?.get('doc_type')?.value || this.docType;
              if (QuotationComponent.shouldDeliverAfterImmediate(state, docType)) {
                this.submitState(SalesOrderState.DELIVERED);
              }
            });
          });
        } else {
          this.loadOrder(); // Rafraîchit l'affichage (ex: livraison simplement planifiée ou fermée sans validation)
        }
      });
  }

  /**
   * Détermine si une commande doit passer à l'état « Livré » après la validation / signature d'un BL.
   * On n'envoie « Livré » que pour une commande encore « En préparation » (PREPARATION),
   * et jamais pour un contrat de location (LOCATION).
   *
   * @param state État actuel de la commande
   * @param docType Type de document de la commande
   * @returns true si la commande doit passer à l'état Livré
   */
  static shouldDeliverAfterImmediate(state: string | null | undefined, docType: string | null | undefined): boolean {
    return getStateEnum(state) === SalesOrderState.PREPARATION && docType !== DocType.LOCATION;
  }

  /** Les adresses du client courant (lignes de rôle -5), pour les deux sélecteurs de l'en-tête. */
  get customerAddresses(): any[] {
    return Partner.addresses(this.customer);
  }

  /** Les adresses du tiers bénéficiaire (livraison) en mode tiers multiple. */
  get beneficiaryAddresses(): any[] {
    return Partner.addresses(this.beneficiary);
  }

  get beneficiary_label(): string {
    return this.beneficiary ? `${this.beneficiary.firstname ?? ''} ${this.beneficiary.name ?? ''}`.trim() : '';
  }

  /** La fiche du client de la commande, au clic sur son nom : la fiche tiers,
   *  fenêtre 96 % × 94 % — le même triplet que PartnerComponent.openRelated, les
   *  deux bougent ensemble. Au retour, la fenêtre rend le formulaire du tiers : la commande y
   *  relit son client (nom, adresses). */
  openPartnerDialog(idpartner: Number) {
    const dialogRef = this.dialog.open(PartnerComponent, {
      width: '96%',
      height: '94%',
      maxWidth: '96vw',
      data: { mode: 'DIALOG', id: idpartner },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((newcustomer: any) => {
        // Un retour vide (fermée pendant le chargement) ne doit JAMAIS détacher le client de la
        // commande — ce lien est le seul accès à la fiche quand le sélecteur est verrouillé.
        if (newcustomer && newcustomer.id) {
          const before = this.partnerRefsKey();
          if (+newcustomer.id === +this.beneficiary?.id) {
            this.beneficiaryRefreshed(newcustomer);
          } else {
            this.customerRefreshed(newcustomer);
          }
          // Enregistrer seulement si la relecture a changé la pièce (adresse neuve retenue, retour FSE) : fermer la fiche sans rien y changer n'écrit rien.
          if (this.partnerRefsKey() !== before && this.canSave && !this.orderBlockedReason) {
            this.onSubmit();
          }
        }
      });
  }

  // Ce que customerRefreshed / beneficiaryRefreshed écrivent dans la pièce et que le serveur garde (lnk_customer n'est qu'une jointure de lecture).
  private partnerRefsKey(): string {
    const v = this.formGroup?.getRawValue() ?? {};
    return JSON.stringify([v.customer, v.addr_bill, v.addr_deliv]);
  }

  public get cvTooltip(): string {
    // Infobulle du bouton carte vitale : le motif du grisage prime
    return this.cvBlockedReason ?? 'Lire carte vitale';
  }

  // Le geste carte vitale est MASQUÉ (et non grisé) sur le comptoir et la commande : la FSE n'y a
  // pas cours, l'infobulle n'aurait aucun motif à donner. Décision JP du 22/09/2026.
  // En mode « tiers multiple », le bouton carte vitale disparaît également.
  public get cvVisible(): boolean {
    if (this.isDistinctBeneficiary) return false;
    const type = (this.formGroup?.get('doc_type')?.value ?? this.docType) as DocType;
    return type !== DocType.TICKET;
  }

  // Motif de fermeture de « Enregistrer » et « Valider » sur les contrats de location seuls (règle : aucun autre blocage).
  // null = geste ouvert, sinon le texte part tel quel en infobulle et en alerte.
  public get orderBlockedReason(): string | null {
    const type = (this.formGroup?.get('doc_type')?.value ?? this.docType) as DocType;
    if (type !== DocType.LOCATION) return null;

    if (!this.customer || !(this.customer.id > 0)) {
      return 'Un contrat de location ne peut être ni enregistré ni validé sans client : choisissez-en un';
    }
    if (this.isDistinctBeneficiary) {
      if (!this.beneficiary || !(this.beneficiary.id > 0)) {
        return 'Bénéficiaire non renseigné : choisissez le tiers à livrer';
      }
      if (!this.formGroup?.get('addr_deliv')?.value) {
        return "Le tiers bénéficiaire n'a aucune adresse de livraison : complétez sa fiche avant d'enregistrer le contrat de location";
      }
    } else {
      if (!this.formGroup?.get('addr_deliv')?.value) {
        return "Ce client n'a aucune adresse de livraison : complétez sa fiche avant d'enregistrer le contrat de location";
      }
    }
    return null;
  }

  // « Plannifier liv » est MASQUÉ sur la vente comptoir : le ticket est livré sur-le-champ (le front
  // pose lui-même une livraison comptoir signée à chaque enregistrement). Décision JP du 22/09/2026.
  public get deliveryVisible(): boolean {
    const type = (this.formGroup?.get('doc_type')?.value ?? this.docType) as DocType;
    return type !== DocType.TICKET;
  }

  // « Plannifier liv » : adresse exigée sur tous les types, validation exigée sur COMMANDE et FACTURE_FSE.
  // — Un BL planifié en CRÉATION engagerait des lignes encore modifiables. Décision JP du 22/09/2026.
  // — Pour FACTURE_FSE, la commande doit être au moins en PREPARATION (créances générées et lignes figées)
  //   avant de pouvoir programmer le BL de livraison à domicile.
  public get deliveryBlockedReason(): string | null {
    // Back-stop du masquage comptoir : le geste n'existe pas sur un TICKET, quelle que soit l'entrée.
    if (!this.deliveryVisible) return "La vente comptoir est livrée sur-le-champ : il n'y a pas de livraison à planifier";
    if (!this.formGroup?.get('addr_deliv')?.value) return 'Aucune adresse de livraison sur ce document : choisissez-en une avant de planifier';
    const type = (this.formGroup?.get('doc_type')?.value ?? this.docType) as DocType;
    if ((type === DocType.FACTURE || type === DocType.FACTURE_FSE) && (!this.id || this.formGroup?.get('state')?.value === SalesOrderState.CREATED)) return 'Validez la commande avant de programmer une livraison';
    return null;
  }

  openRecipientsDialog() {
    // Open recipient selector, then open partner selector w/ firstname / name filled
    // La garde reprend le grisage du bouton : disabledInteractive le laisse FOCUSABLE pour que
    // l'infobulle s'affiche, donc sans elle un Entrée au clavier ouvrirait le tunnel FSE sans
    // identité PS — `numIdentFact` undefined descend jusqu'à Area et l'échec ressort bien plus loin.
    // cvBlockedReason et non fseBlockedReason : le motif « document repris » doit fermer la
    // porte au même titre qu'un défaut de paramétrage.
    if (this.cvBlockedReason !== null || !this.numIdentFact) return;

    const fseActions: QuotationFseActions = {
      patchFormGroupState: (state: SalesOrderState) => this.formGroup.patchValue({ state }),
      patchFormGroupCustomer: (customer: number) => {
        this.customer = undefined;
        this.formGroup.get('customer')?.patchValue(customer);
      },
      patchFormGroupDocType: (docType: DocType) => {
        this.docType = docType;
        this.formGroup.get('doc_type')?.patchValue(docType);
      },
      patchFormGroupFseId: (fseId: number) => {
        const currentData = this.formGroup.get('data')?.value || {};
        this.formGroup.get('data')?.patchValue({ ...currentData, fse_id: fseId });
      },
      submitForm: cb => this.onSubmit(cb),
      openPartnerDialog: idpartner => this.openPartnerDialog(idpartner),
      triggerActionBarAction: action => this.onActionBarAction(action),
      reloadAfterMigrationFse: () => this.create_or_load_order(this.id),
    };

    const isLocation = this.docType === DocType.LOCATION;
    const isMigration = this.canCreateFseOnMigratedOrder;
    const isReissue = this.canReissueFse;

    this.quotationFseProcessorService
      .initiateFSEProcess(
        this.id,
        this.area_baseurl,
        this.loginService.loggeduser?.id,
        this.loginService.currentstation,
        this.configarea,
        this.numIdentFact,
        fseActions,
        isLocation,
        isMigration,
        isReissue,
      )
      .pipe(
        takeUntilDestroyed(this.destroyRef), // Apply takeUntilDestroyed for the service's observable
      )
      .subscribe();
  }

  private parseDateString(dateString: any): Date | undefined {
    if (!dateString) return undefined;
    if (typeof dateString === 'string') {
      let normalized = dateString;
      if (/(?:[+-]\d{2})$/.test(normalized)) {
        normalized += ':00';
      }
      const d = new Date(normalized);
      return isNaN(d.getTime()) ? undefined : d;
    }
    return dateString;
  }

  datState(state: any): Date | undefined {
    const datesObj = this.formGroup.get('dates')?.value;
    if (state !== undefined && state != null && datesObj) {
      const stateKey = getStateKey(state);
      if (stateKey && datesObj[stateKey]) {
        return this.parseDateString(datesObj[stateKey]);
      }
    }
    return undefined;
  }

  selectedIndexChange(e: any) {
    this.selectedtab = e;
  }

  deliveryChangeIsValidable(isValidable: boolean = true) {
    this.isValidable = isValidable;
  }

  get datCurrentState(): Date | undefined {
    // Get formatted date for current status
    let state = this.formGroup.get('state')?.value;
    const datesObj = this.formGroup.get('dates')?.value;
    if (state !== undefined && state != null && datesObj) {
      const stateKey = getStateKey(state);
      if (stateKey && datesObj[stateKey]) {
        return this.parseDateString(datesObj[stateKey]);
      }
    }
    return undefined;
  }

  /**
   * Fil des états franchis par la pièce, du plus ancien au plus récent. C'est le contenu brut de
   * `dates` ({ created, preparation, paid… }), dont les clés SONT les états en minuscules — la même
   * convention que `getStateKey`, sur laquelle s'appuient déjà `datState` et `datCurrentState`.
   *
   * Tri sur la DATE, et non sur un ordre de cycle codé en dur : une vente comptoir saute des états
   * (création → paiement), et le serveur reste libre d'en ajouter sans qu'on ait à retoucher l'écran.
   * Une clé inconnue du référentiel n'est pas escamotée : elle s'affiche telle quelle plutôt que de
   * disparaître ou de s'appeler « Inconnu ».
   */
  get stateTrail(): { key: string; label: string; date: Date; color: string; current: boolean }[] {
    const datesObj = this.formGroup?.get('dates')?.value as Record<string, string | Date> | null | undefined;
    if (!datesObj) return [];
    const currentKey = getStateKey(this.formGroup.get('state')?.value);

    return Object.entries(datesObj)
      .map(([key, raw]) => ({ key, date: this.parseDateString(raw) }))
      .filter((e): e is { key: string; date: Date } => e.date !== undefined)
      .sort((a, b) => a.date.getTime() - b.date.getTime())
      .map(e => {
        const current = e.key === currentKey;
        return {
          key: e.key,
          // `remainder` n'est passé que sur l'étape COURANTE : c'est lui qui change « En paiement »
          // en « Soldé », et cet affinage ne vaut que pour l'état actuel — pas pour un passage
          // historique, où seule la transition compte.
          label: getStateEnum(e.key) ? getOrderLabel(e.key, current ? this.remainder : undefined) : e.key,
          date: e.date,
          color: getOrderColor(e.key),
          current,
        };
      });
  }

  get customer_label(): String {
    let ret = 'Non renseigné';
    let name = this.customer && this.customer.name ? this.customer.name : '';
    let firstname = this.customer && this.customer.firstname ? this.customer.firstname : '';
    if (firstname + name !== '') ret = firstname + ' ' + name;
    return ret;
  }

  formatAddress = (ad: Partner): string => {
    // Une seule ligne : N° et rue (street1) + CP ville suffisent à distinguer les adresses ; bât./appart. (street2/3) sont réservés à l'impression.
    return `${ad.street1 || ''} ${ad.zip || ''} ${ad.city || ''}`.replace(/\s+/g, ' ').trim();
  };

  readonly DOC_MAP: Record<DocType, DocMetadata> = {
    [DocType.TICKET]: {
      css: 'classComptoir primary-light',
      label: 'Vente Comptoir (sans livraison)',
      icon: 'storefront',
      subtitle: 'Vente directe au comptoir sans livraison',
    },
    [DocType.LOCATION]: {
      css: 'classLocation secondary-light',
      label: 'Location Médicale',
      icon: 'event_repeat',
      subtitle: 'Contrat de location de matériel et dispositifs médicaux',
    },
    [DocType.FACTURE]: {
      css: 'classCommande tertiary-light',
      label: 'Commande avec possibilité de livraison',
      icon: 'local_shipping',
      subtitle: 'Commande client avec suivi et possibilité de livraison',
    },
    [DocType.AVOIR]: {
      css: 'classCorrection warning-light',
      label: 'Avoir / Annulation',
      icon: 'assignment_return',
      subtitle: 'Avoir financier, reprise de matériel ou annulation de vente',
    },
    [DocType.FACTURE_ACOMPTE]: {
      css: 'classAcompte warning-light',
      label: "Facture d'acompte",
      icon: 'receipt_long',
      subtitle: "Facture d'acompte (art. 269-2-c du CGI)",
    },
    [DocType.FACTURE_FSE]: {
      css: 'classFse primary-light',
      label: 'Facture FSE (Feuille de Soins Électronique)',
      icon: 'receipt_long',
      subtitle: 'Facture de soins électronique télétransmise (AMO / AMC)',
    },
  };

  /**
   * « caisse 1 (LVM la seyne) » — le poste de travail et l'établissement d'où la commande a été
   * SAISIE, lus sur la pièce elle-même. À ne pas confondre avec `loginService.currentstore`, qui
   * disait où se trouve l'utilisateur en train de regarder : sur une commande passée ailleurs, cette
   * valeur-là était fausse.
   * Chaîne vide tant que la station est inconnue (commande neuve, référentiel non chargé, station
   * supprimée) : le gabarit n'affiche alors aucune puce.
   */
  get orderStationLabel(): string {
    const stationId = this.formGroup?.controls.station?.value;
    if (!stationId) return '';
    if (this.stationLabelCache?.id === stationId) return this.stationLabelCache.label;

    const station = this.stations.find(s => s.id === stationId);
    const store = station ? this.stores.find(s => s.id === station.store) : undefined;
    const label = !station?.name ? '' : store?.name ? `${station.name} (${store.name})` : station.name;

    this.stationLabelCache = { id: stationId, label };
    return label;
  }

  /**
   * Identifiant du contrat de location parent lorsque la commande courante est issue d'une facturation récurrente.
   * Retourne null s'il s'agit d'une commande autonome ou sans rattachement parent.
   */
  get parentOrderId(): number | null {
    const pId = this.formGroup?.get('data')?.value?.parent_order_id;
    return pId ? Number(pId) : null;
  }

  /**
   * Identifiant de l'avoir lié si cette pièce a été annulée.
   */
  get avoirOrderId(): number | null {
    const aId = this.formGroup?.get('data')?.value?.avoir_order_id;
    return aId ? Number(aId) : null;
  }

  /**
   * Indique si le document courant est une commande fille issue d'un contrat de location.
   * Ne s'applique pas aux avoirs ni aux acomptes, même s'ils référencent une commande parente.
   */
  get isRentalChildOrder(): boolean {
    const type = this.formGroup?.get('doc_type')?.value || this.docType;
    return !!this.parentOrderId && type !== DocType.AVOIR && type !== DocType.FACTURE_ACOMPTE;
  }

  // Facture de location (parent dossier ou ligne au registre) : ni annulation ni avoir à la main, le dossier décide (JP 26/10).
  get isRentalInvoice(): boolean {
    return isRentalInvoice(this.formGroup?.get('doc_type')?.value || this.docType, this.formGroup?.get('data')?.value, this.formGroup?.get('lines')?.value);
  }

  /**
   * Infobulle du lien vers le document parent.
   */
  get parentOrderTooltip(): string {
    const pId = this.parentOrderId ? formatNumber(this.parentOrderId, 'fr', '1.0-0') : '';
    const type = this.formGroup?.get('doc_type')?.value || this.docType;
    if (type === DocType.AVOIR) {
      return `Accéder au document d'origine N° ${pId}`;
    }
    if (type === DocType.FACTURE_ACOMPTE) {
      return `Accéder à la commande principale N° ${pId}`;
    }
    return `Accéder au contrat de location source N° ${pId}`;
  }

  get currentOrderClass(): string {
    const type = this.formGroup.get('doc_type')?.value || this.docType;
    return type && this.DOC_MAP[type] ? this.DOC_MAP[type].css : 'default-class';
  }

  /**
   * Libellé principal affiché dans l'en-tête du document.
   * Pour une commande issue d'un contrat de location, remplace le libellé générique de livraison
   * par l'indication explicite de filiation locative.
   */
  get currentOrderLabel(): string {
    if (this.isRentalChildOrder) {
      return 'Commande issue du contrat de location';
    }
    const type = this.formGroup.get('doc_type')?.value || this.docType;
    return type && this.DOC_MAP[type] ? this.DOC_MAP[type].label : 'Document type INCONNU';
  }

  /**
   * Icône de l'en-tête.
   * Affiche l'icône de récurrence locative `event_repeat` pour une facture issue d'un contrat,
   * à la place de l'icône générique de livraison `local_shipping`.
   */
  get currentOrderIcon(): string {
    if (this.isRentalChildOrder) {
      return 'event_repeat';
    }
    const type = this.formGroup.get('doc_type')?.value || this.docType;
    return type && this.DOC_MAP[type] ? this.DOC_MAP[type].icon : 'description';
  }

  /**
   * Sous-titre informatif de la commande.
   * Pour une commande issue d'une location, extrait les informations de la période facturée :
   * index de la période, date de début (et de fin).
   */
  get currentOrderSubtitle(): string {
    const type = this.formGroup.get('doc_type')?.value || this.docType;
    if (type === DocType.AVOIR) {
      if (this.parentOrderId) {
        return `Avoir rattaché au document d'origine `;
      }
      return this.DOC_MAP[DocType.AVOIR].subtitle;
    }
    if (type === DocType.FACTURE_ACOMPTE) {
      if (this.parentOrderId) {
        return `Facture d'acompte rattachée à la commande `;
      }
      return this.DOC_MAP[DocType.FACTURE_ACOMPTE].subtitle;
    }
    if (this.isRentalChildOrder) {
      const lines = this.formGroup?.get('lines')?.value;
      if (Array.isArray(lines)) {
        // Registre data.rental_billing des lignes de location : rangs facturés rank_start à rank_end, BT-134 = start et BT-135 = end (dernier jour, inclus),
        // jours en instants de Paris à midi, relus en jours par businessDayOf, qui écarte une valeur illisible.
        const billings = lines.filter((l: any) => l?.typ === OrderLineType.RENTAL || l?.typ === 6).map((l: any) => rentalBillingOf(l)).filter((b: RentalBilling | null): b is RentalBilling => b !== null);
        if (billings.length > 0) {
          const spans = Array.from(new Set(billings.map(b => `${b.rank_start}|${b.rank_end}`))).map(k => k.split('|').map(Number)).sort((a, b) => a[0] - b[0] || a[1] - b[1]);
          const several = spans.length > 1 || spans[0][0] !== spans[0][1];
          const indexLabel = `${several ? 'Périodes facturées' : 'Période facturée'} n° ${spans.map(([rs, re]) => (rs === re ? `${rs}` : `${rs} à ${re}`)).join(', ')}`;
          const starts = billings.map(b => businessDayOf(b.start)).filter((d): d is string => !!d).sort();
          const ends = billings.map(b => businessDayOf(b.end)).filter((d): d is string => !!d).sort();
          const fr = (d: string) => `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}`;
          if (starts.length && ends.length) {
            return `${indexLabel} • Date de début : ${fr(starts[0])} (au ${fr(ends[ends.length - 1])})`;
          }
          return indexLabel;
        }
      }
      return `Rattachée au contrat de location N° ${this.parentOrderId}`;
    }

    return type && this.DOC_MAP[type] ? this.DOC_MAP[type].subtitle : '';
  }

  customerChange(newcustomer: any) {
    console.log('newcustomer', newcustomer);
    // En-tête fermé (pièce reprise, annulée, soldée…) : ni rattacher ni détacher le client ; customerRefreshed a la même garde.
    if (!this.canEditHeader) return;
    this.customer = newcustomer;
    this.loadCustomerEventsSubject.next(newcustomer);
    // // For dev
    // this.openPartnerDialog(newcustomer.id)
    // this.loadCustomerEventsSubject.next(undefined);
    this.cvlookup = false; // Switch to name lookup
    if (!newcustomer) {
      // old resetClient
      this.formGroup.get('customer')?.setValue(0);
      this.formGroup.get('lnk_customer')?.reset();
      this.cvlookup = false;
      this.formGroup.get('addr_bill')?.disable();
      if (!this.isDistinctBeneficiary) {
        this.formGroup.get('addr_deliv')?.disable();
      }
    } else {
      this.formGroup.get('customer')?.patchValue(newcustomer.id);
      if (!this.formGroup.get('lnk_customer')) {
        // this.formGroup.addControl('lnk_customer', new FormControl(newcustomer)); FIXME remove comment
      } else {
        this.formGroup.get('lnk_customer')?.patchValue(newcustomer); // TODO Patching w/ complex type is problematic. lnk_customer should probably be a FormControl<any> or FormControl<Partner>
      }
      // Les adresses du client sont ses lignes de rôle -5 (c_partner_partner) ; l'adresse par défaut
      // de chaque qualité est la ligne de rôle -1 (facturation) ou -2 (livraison) qui porte
      // is_default. À défaut, la première adresse.
      const adresses = Partner.addresses(newcustomer);
      if (adresses.length) {
        const addr_bill = Partner.defaultAddress(newcustomer, PARTNER_PARTNER_ROLE_BILL)?.id ?? adresses[0].id;
        this.formGroup.get('addr_bill')?.patchValue(addr_bill);
        this.formGroup.get('addr_bill')?.enable();
        if (!this.isDistinctBeneficiary) {
          const addr_deliv = Partner.defaultAddress(newcustomer, PARTNER_PARTNER_ROLE_DELIV)?.id ?? adresses[0].id;
          this.formGroup.get('addr_deliv')?.patchValue(addr_deliv);
          this.formGroup.get('addr_deliv')?.enable();
        }
      } else {
        this.formGroup.get('addr_bill')?.disable();
        if (!this.isDistinctBeneficiary) {
          this.formGroup.get('addr_deliv')?.disable();
        }
      }

      if (newcustomer.data && newcustomer.data.cufs && newcustomer.data.cufs[cufSystem.PARTNER_IS_HT]) {
        this.is_ht = newcustomer.data.cufs[cufSystem.PARTNER_IS_HT];
      }
    }
    // document.getElementById('searchinput')?.focus() // TODO no searchinput field
  }

  // Retour de la fiche client : on RELIT le client sans rejouer un choix, les adresses retenues restent tant qu'il les a encore (doc front.sales.quotation.customer-refresh).
  customerRefreshed(p: any): void {
    if (!p?.id || !this.canEditHeader) return;
    // Re-tarifer (loadCustomerEventsSubject → quotationgeneral.customerChange) réécrit unet_* de chaque ligne : réservé à un changement de client ou de tarif.
    const repricing = +this.customer?.id !== +p.id || JSON.stringify(this.customer?.data?.pricelists ?? null) !== JSON.stringify(p?.data?.pricelists ?? null);
    this.customer = p;
    if (repricing) this.loadCustomerEventsSubject.next(p);
    this.formGroup.get('customer')?.patchValue(p.id);
    this.formGroup.get('lnk_customer')?.patchValue(p);
    const addresses = Partner.addresses(p);
    const rolesToRefresh: [string, number][] = this.isDistinctBeneficiary
      ? [['addr_bill', PARTNER_PARTNER_ROLE_BILL]]
      : [
          ['addr_bill', PARTNER_PARTNER_ROLE_BILL],
          ['addr_deliv', PARTNER_PARTNER_ROLE_DELIV],
        ];
    for (const [name, role] of rolesToRefresh) {
      const ctrl = this.formGroup.get(name);
      if (!ctrl) continue;
      if (!addresses.length) {
        ctrl.disable();
        continue;
      }
      // L'appartenance est vérifiée sur la liste RELUE : une valeur héritée d'un autre client
      // (le résidu que customerChange laisse quand le client n'a pas d'adresse) ne survit pas.
      const kept = addresses.some((a: any) => +a.id === +ctrl.value);
      ctrl.patchValue(kept ? ctrl.value : (Partner.defaultAddress(p, role)?.id ?? addresses[0].id));
      ctrl.enable();
    }
    if (p.data?.cufs?.[cufSystem.PARTNER_IS_HT]) this.is_ht = p.data.cufs[cufSystem.PARTNER_IS_HT];
  }

  onDistinctBeneficiaryChange(checked: boolean): void {
    if (!this.canEditHeader) return;
    this.isDistinctBeneficiary = checked;
    const currentData = this.formGroup?.get('data')?.value || {};

    if (checked) {
      if (!this.beneficiary) {
        this.formGroup?.get('addr_deliv')?.setValue(0);
        this.formGroup?.get('addr_deliv')?.disable();
      } else {
        const delivAddrs = Partner.addresses(this.beneficiary);
        const defAddr = Partner.defaultAddress(this.beneficiary, PARTNER_PARTNER_ROLE_DELIV)?.id ?? delivAddrs[0]?.id ?? 0;
        this.formGroup?.get('addr_deliv')?.setValue(defAddr);
        if (delivAddrs.length) this.formGroup?.get('addr_deliv')?.enable();
      }
      this.formGroup?.get('data')?.patchValue({
        ...currentData,
        recipient: this.beneficiary?.id ?? null,
      });
    } else {
      this.beneficiary = undefined;
      const { recipient, ...restData } = currentData;
      this.formGroup?.get('data')?.setValue(restData);
      const payerAddrs = Partner.addresses(this.customer);
      if (payerAddrs.length) {
        const defAddr = Partner.defaultAddress(this.customer, PARTNER_PARTNER_ROLE_DELIV)?.id ?? payerAddrs[0]?.id;
        this.formGroup?.get('addr_deliv')?.setValue(defAddr);
        this.formGroup?.get('addr_deliv')?.enable();
      } else {
        this.formGroup?.get('addr_deliv')?.setValue(0);
        this.formGroup?.get('addr_deliv')?.disable();
      }
    }
  }

  beneficiaryChange(newBeneficiary: any): void {
    if (!this.canEditHeader) return;
    this.beneficiary = newBeneficiary;
    const currentData = this.formGroup?.get('data')?.value || {};

    if (!newBeneficiary) {
      this.formGroup?.get('addr_deliv')?.setValue(0);
      this.formGroup?.get('addr_deliv')?.disable();
      const { recipient, ...restData } = currentData;
      this.formGroup?.get('data')?.setValue(restData);
    } else {
      this.formGroup?.get('data')?.patchValue({
        ...currentData,
        recipient: newBeneficiary.id,
      });
      const delivAddrs = Partner.addresses(newBeneficiary);
      if (delivAddrs.length) {
        const defAddr = Partner.defaultAddress(newBeneficiary, PARTNER_PARTNER_ROLE_DELIV)?.id ?? delivAddrs[0]?.id;
        this.formGroup?.get('addr_deliv')?.setValue(defAddr);
        this.formGroup?.get('addr_deliv')?.enable();
      } else {
        this.formGroup?.get('addr_deliv')?.setValue(0);
        this.formGroup?.get('addr_deliv')?.disable();
      }
    }
  }

  beneficiaryRefreshed(p: any): void {
    if (!p?.id || !this.canEditHeader) return;
    this.beneficiary = p;
    const addresses = Partner.addresses(p);
    const ctrl = this.formGroup?.get('addr_deliv');
    if (!ctrl) return;
    if (!addresses.length) {
      ctrl.setValue(0);
      ctrl.disable();
      return;
    }
    const kept = addresses.some((a: any) => +a.id === +ctrl.value);
    ctrl.patchValue(kept ? ctrl.value : (Partner.defaultAddress(p, PARTNER_PARTNER_ROLE_DELIV)?.id ?? addresses[0].id));
    ctrl.enable();
  }

  ngOnDestroy() {
    // This lifecycle hook is here for completeness, as takeUntilDestroyed is handling subscriptions.
  }

  // Le panneau latéral s'ouvre dès qu'il a quelque chose à montrer : un client (son historique) ou
  // une pièce enregistrée (ses documents).
  get hasCustomer(): boolean {
    return !!this.customer?.id && +this.customer.id > 0;
  }

  // Onglet ouvert en premier, le seul à lancer une requête (contenus créés à l'ouverture) : l'historique sur une saisie en cours, les documents ailleurs.
  get historyByDefault(): boolean {
    return this.hasCustomer && this.formGroup?.value?.state === SalesOrderState.CREATED;
  }

  // ============================================================
  // CONSULTATION SEULE — documents repris de l'ancien ERP (état MIGRATION)
  // ============================================================
  //
  // Le verrou de fond est SERVEUR : process_order_update n'a aucun bras pour cet état et
  // refuse tout enregistrement (sales/src/order/model.rs). Ce qui suit ne protège donc pas
  // l'intégrité — elle l'est déjà — mais évite de laisser croire à l'utilisateur qu'il
  // modifie une pièce, pour lui servir une erreur technique brute au moment d'enregistrer.
  //
  // Le prédicat vit dans shared/constants.ts : les composants enfants (lignes, barre
  // d'action) doivent trancher sur la MÊME règle, jamais sur une condition d'affichage
  // qui exclurait MIGRATION par hasard.
  get isReadOnly(): boolean {
    return isSealedOrder(this.formGroup?.get('state')?.value);
  }

  /**
   * Détermine si la commande est enregistrable directement depuis le formulaire.
   * Utilise en priorité les capacités servies par le backend (`allowed_actions` contenant SAVE)
   * ou se replie sur le prédicat métier `isOrderEditable`.
   */
  get canSave(): boolean {
    const allowed = this.formGroup?.get('allowed_actions')?.value;
    if (Array.isArray(allowed) && allowed.length > 0) {
      return allowed.includes(SalesOrderAction.SAVE);
    }
    return isOrderEditable(this.formGroup?.get('state')?.value);
  }

  // Client, adresses, carte vitale : la liste du serveur fait foi, même vide (pièce annulée) ; null = pièce neuve jamais relue, règle locale.
  get canEditHeader(): boolean {
    const allowed: string[] | null | undefined = this.formGroup?.get('allowed_actions')?.value;
    if (Array.isArray(allowed)) return allowed.includes(SalesOrderAction.EDIT_HEADER) || (allowed as any).includes('EDITHEADER');
    return Sales_order.computeLocalAllowedActions(this.formGroup?.get('state')?.value).includes(SalesOrderAction.EDIT_HEADER);
  }

  /**
   * [release-fse-orthop] Exception isolée : autorise le lancement du tunnel FSE (lecture Carte Vitale)
   * sur une facture reprise d'Orthop (`state === MIGRATION` et `doc_type === FACTURE`), afin de permettre
   * la réémission d'une FSE rejetée ou manquante sans déverrouiller la pièce (`isReadOnly` reste `true`)
   * ni modifier `sales_order` ou son scellement fiscal (`safe.transaction` d'origine `'EX'`).
   */
  get canCreateFseOnMigratedOrder(): boolean {
    const state = this.formGroup?.get('state')?.value;
    const type = (this.formGroup?.get('doc_type')?.value ?? this.docType) as DocType;
    return Boolean(this.id && state === SalesOrderState.MIGRATION && type === DocType.FACTURE);
  }

  /**
   * Permet la réémission d'une nouvelle FSE lorsque la dernière FSE émise sur une FACTURE_FSE
   * a été rejetée par l'organisme payeur (RSP de rejet).
   * L'exception lève le blocage du bouton Carte Vitale sans déverrouiller la pièce ni muter
   * l'état de la commande ou du scellement fiscal.
   */
  get canReissueFse(): boolean {
    const type = (this.formGroup?.get('doc_type')?.value ?? this.docType) as DocType;
    if (!this.id || type !== DocType.FACTURE_FSE) return false;
    if (!Array.isArray(this.fseOrders) || this.fseOrders.length === 0) return false;
    const sorted = [...this.fseOrders].sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
    const latestFse = sorted[0];
    return Boolean(
      latestFse.lnk_rsp_fses?.some(
        (rsp: any) => rsp.topRejet === '1' || rsp.partAMO?.traitement === 'R' || rsp.payment_status === 'REJECTED',
      ),
    );
  }

  // Motif de fermeture du geste carte vitale, état de la commande COMPRIS. `fseBlockedReason`
  // ne parle que du PARAMÉTRAGE (caisse, compte) et se calcule dans ngOnInit, avant que la
  // commande soit chargée : il ne pouvait pas connaître l'état. Sans cette combinaison, le
  // tunnel FSE restait ouvert sur une pièce reprise — or il patche l'état et enregistre DEUX
  // fois (custom-FSE/fse-processor.service.ts), contournant tout le reste du verrouillage.
  get cvBlockedReason(): string | null {
    // [release-fse-orthop] Exception isolée pour réémettre une FSE sur une facture reprise (FORG/LORG)
    // ou en cas de rejet RSP sur une FACTURE_FSE
    if (this.canCreateFseOnMigratedOrder || this.canReissueFse) return this.fseBlockedReason;
    if (this.isReadOnly) return "Document repris de l'ancien logiciel : consultation seule, la lecture de carte vitale est fermée";
    // Le tunnel FSE rattache le patient et enregistre : il lui faut l'en-tête ouvert.
    if (!this.canEditHeader) return 'Pièce non modifiable dans son état actuel : la lecture de carte vitale est fermée';
    return this.fseBlockedReason;
  }

  isCustomerLocked(state: any): boolean {
    if (!this.id || this.id === 0) return false;
    // isSealedOrder d'abord, explicitement : MIGRATION tombait déjà dans le cas verrouillé
    // parce qu'il n'est pas dans la liste ci-dessous — par construction, pas par intention.
    if (isSealedOrder(state)) return true;
    // Le client fait partie de l'en-tête : sans EDITHEADER (pièce annulée, soldée…), verrouillé quel que soit l'état.
    if (!this.canEditHeader) return true;
    return ![SalesOrderState.CREATED, SalesOrderState.QUOTE].includes(state as SalesOrderState);
  }
}

// Define a clear interface for your metadata
interface DocMetadata {
  css: string;
  label: string;
  icon: string;
  subtitle: string;
}
